import {Button, Col, InputGroup, Nav, Navbar, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React from "react";
import {Link} from "react-router-dom";
import {Formik} from "formik";

export default function Step1(props){

    function saveStep(values){
        props.data.name = values['caseid']
        props.data.deadline = values['deadline'];
        props.data.description = values['description'];
        props.cb(1,props.data)
    }
    return(
        <>

            <Formik
                initialValues={{ caseid: props.data.name, deadline: props.data.deadline, description: props.data.description}}
                validate={values => {
                    const errors = {};
                    if (!values.caseid) {
                        errors.caseid = 'Required';
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    saveStep(values);
                    setSubmitting(false);
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <Row  style={{  marginTop: "20px"}}>
                            <Navbar bg="light" variant="light">

                                <Nav>
                                    <Link to="/">
                                        <Button variant="secondary" >
                                            Back
                                        </Button>
                                    </Link>
                                </Nav>
                                <Nav className="m-auto">
                                    <p className="m-auto"><b>1. General Information</b> <span className="m-3">-</span> 2. Upload Case Files <span className="m-3">-</span> 3. Additional Information</p>
                                </Nav>
                                <Nav>

                                        <Button type="submit" disabled={isSubmitting} variant="primary" >
                                            Next
                                        </Button>
                                </Nav>
                            </Navbar>
                        </Row>
                        <Row className="mt-5">

                            <h5>
                                General Information
                            </h5>
                            <hr/>
                            <Col lg={6}>

                                <span style={{color: "red"}}>{errors.caseid && touched.caseid && errors.caseid}</span>
                                <InputGroup className="mb-3">
                                    <span className="input-group-text">Case ID:</span>
                                    <Form.Control
                                        aria-label="Case ID"
                                        placeholder="THORAX-3"
                                        name="caseid"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.caseid}
                                    />
                                </InputGroup>
                                <InputGroup className="mb-3">
                                    <span className="input-group-text">Deadline:</span>
                                    <Form.Control
                                        type="date"
                                        aria-label="Deadline date"
                                        name="deadline"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.deadline}
                                    />
                                </InputGroup>
                            </Col>


                        </Row>
                        <Row className="mt-5">
                            <h5>
                                Description
                            </h5>
                            <hr/>
                            <Col lg={6}>
                                <p>
                                    Relevant information about the case. It will help observers get to know the case better so that they can create efficient delineations
                                </p>
                                <Form.Group className="mb-3">
                                    <Form.Control as="textarea" rows={5}
                                                  name="description"
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                                  value={values.description}/>
                                </Form.Group>
                            </Col>
                        </Row>
                    </form>
                )}
            </Formik>

        </>
    )
}